import React from 'react';

/**
 * Mapování textových známek na barvy. Aktuální model: green/yellow/red
 * (tercilové pásmo dle pořadí mezi řidiči). Legacy A/B/C/D ponechány
 * pro zpětnou kompatibilitu.
 */
export const ZNAMKA_COLORS = {
    green:  '#3FD78A',
    yellow: '#FFC857',
    red:    '#FF5A6B',
    A: '#3FD78A',
    B: '#0CC0DF',
    C: '#FFC857',
    D: '#FF5A6B',
};

/**
 * Indikátor scoringu řidiče v percentilovém modelu.
 *
 * Hlavní hodnota = `score_pct` (0–100, vyšší = lepší — pozice v žebříčku).
 * Sekundární text = `body_per_km` (čím méně, tím lépe).
 * Barva = tercilová známka (green/yellow/red).
 *
 * Kruh vyplněn proporcionálně dle score_pct (vizuální progress).
 */
export default function ScoreCircle({ scorePct = null, bodyPerKm = null, znamka = '—', size = 88 }) {
    const radius = (size - 12) / 2;
    const circumference = 2 * Math.PI * radius;
    const color = ZNAMKA_COLORS[znamka] || '#9ca3af';
    const validPct = scorePct !== null && scorePct !== undefined && !isNaN(scorePct);
    const offset = validPct
        ? circumference - (Math.max(0, Math.min(100, scorePct)) / 100) * circumference
        : circumference;

    const display = validPct ? `${scorePct}%` : '—';
    const sub = bodyPerKm !== null && bodyPerKm !== undefined && !isNaN(bodyPerKm)
        ? `${Number(bodyPerKm).toFixed(2)} b/km`
        : 'bez dat';

    return (
        <div style={{ position: 'relative', width: size, height: size }}>
            <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
                <circle
                    cx={size / 2} cy={size / 2} r={radius} fill="none"
                    stroke="rgba(155,145,179,0.18)" strokeWidth={6}
                />
                <circle
                    cx={size / 2} cy={size / 2} r={radius} fill="none"
                    stroke={color} strokeWidth={6}
                    strokeDasharray={circumference} strokeDashoffset={offset}
                    strokeLinecap="round" style={{ transition: 'stroke-dashoffset 0.6s ease' }}
                />
            </svg>
            <div style={{
                position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column',
                alignItems: 'center', justifyContent: 'center',
            }}>
                <div style={{ fontSize: size > 100 ? 24 : 20, fontWeight: 800, color, fontFamily: 'JetBrains Mono, monospace', lineHeight: 1 }}>{display}</div>
                <div style={{ fontSize: size > 100 ? 10 : 9, fontWeight: 600, color: 'var(--text-tertiary)', marginTop: 2, fontVariantNumeric: 'tabular-nums' }}>{sub}</div>
            </div>
        </div>
    );
}
